import { NextPage } from "next";
import dynamic from "next/dynamic";
import DynamicLoading from "../component/default/dynamicLoading";
import useMain from "../hooks/useMain";

const DynamicSignup = dynamic(
  () => import("../component/account/dynamicSignup"),
  { ssr: false, loading: () => <DynamicLoading /> }
);

const SignUp: NextPage = () => {
  const { config } = useMain();

  return <DynamicSignup config={config} />;
};

export default SignUp;
